(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thiamar-home-apple"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const items = document.querySelectorAll('.th-apple-home .th-reveal:not(.is-visible)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
      items.forEach((item) => observer.observe(item));
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thiamar-scroll-collage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thiamar-scroll-scene')) {
    customElements.define('thiamar-scroll-scene', class extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
        };
        this.configure = () => {
          this.toggleAttribute('data-scroll-ready', !this.reduceMotion.matches && this.classList.contains('thiamar-arrival--motion'));
          this.schedule();
          if (this.mistTick && this.mistVisible && !this.reduceMotion.matches && !this.mistFrame) this.mistFrame = requestAnimationFrame(this.mistTick);
        };
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        this.reduceMotion.addEventListener('change', this.configure);
        this.mobileImages = [...this.querySelectorAll('.thiamar-arrival__shutter-image')];
        this.imageReady = () => {
          const ready = this.mobileImages.length === 2 && this.mobileImages.every(image => image.complete && image.naturalWidth > 0);
          this.style.setProperty('--ta-mobile-ready', ready ? '1' : '0');
          this.schedule();
        };
        this.mobileImages.forEach(image => image.addEventListener('load', this.imageReady));
        this.imageReady();
        this.configure();
        this.startMist();
      }
      startMist() {
        this.mistCanvases = [...this.querySelectorAll('[data-mist]')];
        this.lakeScenes = {};
        this.mistTexture = document.createElement('canvas');
        this.mistTexture.width = 1024;
        this.mistTexture.height = 128;
        const texture = this.mistTexture.getContext('2d');
        let seed = 281;
        const random = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
        for (let i = 0; i < 48; i++) {
          const baseX = random() * 1024, y = 48 + random() * 32, radius = 22 + random() * 55;
          for (const x of [baseX-1024,baseX,baseX+1024]) {
          const gradient = texture.createRadialGradient(x, y, 0, x, y, radius);
          gradient.addColorStop(0, 'rgba(235,244,249,0.30)');
          gradient.addColorStop(.4, 'rgba(235,244,249,0.12)');
          gradient.addColorStop(1, 'rgba(235,244,249,0)');
          texture.fillStyle = gradient;
          texture.fillRect(x-radius, y-radius, radius*2, radius*2);
          }
        }
        this.mistTick = time => {
          this.mistFrame = 0;
          if (!this.mistVisible || this.reduceMotion.matches || document.hidden) return;
          if (!this.lastMistTime || time - this.lastMistTime >= 32) {
            this.lastMistTime = time;
            this.mistCanvases.forEach(canvas => this.drawMist(canvas, time / 1000));
          }
          this.mistFrame = requestAnimationFrame(this.mistTick);
        };
        this.wakeLake = () => {
          if (this.mistVisible && !document.hidden && !this.mistFrame && !this.reduceMotion.matches) this.mistFrame = requestAnimationFrame(this.mistTick);
        };
        document.addEventListener('visibilitychange', this.wakeLake);
        this.mistObserver = new IntersectionObserver(entries => {
          this.mistVisible = entries[0].isIntersecting;
          this.wakeLake();
        });
        this.mistObserver.observe(this);
      }
      createLake(mobile) {
        const scene = { image: new Image(), mobile, ready: false, frame: -1 };
        scene.image.crossOrigin = 'anonymous';
        scene.image.onload = () => {
          if (!this.isConnected) return;
          scene.surface = document.createElement('canvas');
          scene.surface.width = mobile ? 840 : 1440;
          scene.surface.height = Math.round(scene.surface.width * scene.image.naturalHeight / scene.image.naturalWidth);
          scene.context = scene.surface.getContext('2d');
          scene.fog = document.createElement('canvas');
          scene.fog.width = scene.surface.width;
          scene.fog.height = scene.surface.height;
          scene.mask = this.lakeMask(scene.surface.width, scene.surface.height, mobile);
          scene.gpu = this.lakeRenderer(scene.image, scene.mask);
          scene.ready = true;
        };
        scene.image.src = mobile ? this.dataset.lakeMobile : this.dataset.lakeDesktop;
        return scene;
      }
      lakeMask(width, height, mobile) {
        const mask = document.createElement('canvas');
        mask.width = width; mask.height = height;
        const context = mask.getContext('2d');
        const polygon = points => {
          context.beginPath();
          points.forEach(([x,y], index) => index ? context.lineTo(x*width,y*height) : context.moveTo(x*width,y*height));
          context.closePath(); context.fill();
        };
        context.fillStyle = '#fff';
        context.filter = 'blur(3px)';
        if (mobile) {
          polygon([[0,.347],[1,.347],[1,.452],[.961,.466],[.93,.477],[.888,.485],[.78,.53],[.598,.551],[.55,.554],[.528,.55],[.50,.553],[.455,.556],[.435,.561],[.408,.568],[.404,.551],[.39,.54],[.365,.537],[.345,.544],[.332,.551],[.31,.548],[.285,.542],[.25,.544],[.212,.53],[.188,.519],[.157,.517],[.129,.508],[.10,.506],[.086,.5],[.06,.501],[.033,.494],[0,.488]]);
          context.globalCompositeOperation = 'destination-out';
          polygon([[.622,.394],[.704,.389],[.799,.382],[.862,.387],[.862,.406],[.779,.417],[.77,.431],[.83,.441],[.947,.436],[.949,.455],[.934,.476],[.99,.504],[1,.62],[.551,.622],[.556,.533],[.574,.508],[.599,.49],[.627,.484],[.644,.472],[.592,.47],[.588,.458],[.622,.45],[.675,.443],[.68,.422],[.631,.417]]);
          polygon([[.347,.48],[.385,.476],[.434,.474],[.482,.475],[.522,.474],[.587,.478],[.594,.497],[.55,.508],[.508,.51],[.516,.58],[.451,.58],[.45,.509],[.368,.503],[.346,.5]]);
        } else {
          polygon([[0,.389],[.422,.389],[.426,.507],[.412,.551],[.406,.584],[.402,.622],[.351,.611],[.336,.65],[.30,.65],[.28,.62],[.279,.59],[.294,.575],[.291,.566],[.276,.558],[.247,.58],[.226,.565],[.207,.552],[.193,.532],[.167,.506],[.15,.485],[.123,.47],[.10,.463],[.078,.466],[.059,.48],[.057,.513],[.06,.535],[0,.541]]);
          polygon([[.469,.39],[.729,.39],[.725,.403],[.681,.423],[.677,.44],[.709,.455],[.706,.481],[.675,.489],[.662,.514],[.651,.542],[.646,.579],[.621,.583],[.603,.576],[.601,.561],[.586,.554],[.57,.553],[.557,.55],[.546,.541],[.53,.543],[.522,.553],[.516,.575],[.502,.594],[.469,.59],[.459,.579],[.457,.55],[.468,.514]]);
          polygon([[.934,.435],[.952,.424],[.98,.412],[1,.397],[1,.487],[.983,.497],[.976,.51],[.965,.515],[.945,.505],[.927,.507]]);
        }
        if (!mobile) {
          context.globalCompositeOperation = 'destination-out';
          polygon([[.063,.454],[.089,.444],[.12,.452],[.146,.478],[.187,.545],[.24,.655],[.285,.804],[.18,.87],[.061,.593],[.048,.496]]);
        }
        context.filter = 'none';
        context.globalCompositeOperation = 'source-over';
        return mask;
      }
      lakeRenderer(image, mask) {
        const canvas = document.createElement('canvas');
        canvas.width = mask.width; canvas.height = mask.height;
        const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false, preserveDrawingBuffer: true });
        if (!gl) return null;
        const shader = (type, source) => {
          const item = gl.createShader(type);
          gl.shaderSource(item, source); gl.compileShader(item);
          if (!gl.getShaderParameter(item, gl.COMPILE_STATUS)) { gl.deleteShader(item); return null; }
          return item;
        };
        const vertex = shader(gl.VERTEX_SHADER, 'attribute vec2 position; varying vec2 uv; void main(){uv=vec2((position.x+1.0)*.5,(1.0-position.y)*.5);gl_Position=vec4(position,0.,1.);}');
        const fragment = shader(gl.FRAGMENT_SHADER, `
          precision highp float;
          varying vec2 uv;
          uniform sampler2D photo;
          uniform sampler2D waterMask;
          uniform float time;
          uniform float horizon;
          uniform float depthRange;
          void main() {
            float alpha=texture2D(waterMask,uv).a;
            if(alpha<.003){gl_FragColor=vec4(0.);return;}
            float d=clamp((uv.y-horizon)/depthRange,0.,1.);
            float perspective=log(1.+d*8.);
            float phase=perspective*63.-time*2.65;
            float wave=sin(phase+sin(uv.x*19.+time*.36)*1.8);
            float crossWave=sin(perspective*104.+uv.x*27.-time*3.8);
            float fine=sin(perspective*182.-uv.x*41.-time*4.7);
            float amplitude=pow(d,1.22)*smoothstep(0.,.035,uv.y-horizon);
            vec2 offset=vec2((wave*.0038+crossWave*.0019)*amplitude,(wave*.0021+crossWave*.0011+fine*.00035)*amplitude);
            float safe=texture2D(waterMask,uv+offset*2.).a;
            offset*=smoothstep(.1,.95,safe);
            vec3 color=texture2D(photo,uv+offset).rgb;
            float slope=cos(phase+sin(uv.x*19.+time*.36)*1.8);
            float glint=pow(max(0.,slope),12.)*pow(max(0.,sin(uv.x*83.+perspective*28.-time*1.3)),5.);
            float sunlight=exp(-pow((uv.x-.105)/.16,2.));
            color*=1.+(wave*.055+crossWave*.025)*amplitude;
            color+=vec3(1.,.90,.70)*glint*(.012+sunlight*.14)*amplitude;
            gl_FragColor=vec4(color,alpha);
          }
        `);
        if (!vertex || !fragment) { gl.getExtension('WEBGL_lose_context')?.loseContext(); return null; }
        const program = gl.createProgram();
        gl.attachShader(program, vertex); gl.attachShader(program, fragment); gl.linkProgram(program);
        gl.deleteShader(vertex); gl.deleteShader(fragment);
        if (!gl.getProgramParameter(program,gl.LINK_STATUS)) { gl.getExtension('WEBGL_lose_context')?.loseContext(); return null; }
        gl.useProgram(program);
        const buffer = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,buffer);
        gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
        const position=gl.getAttribLocation(program,'position');
        gl.enableVertexAttribArray(position); gl.vertexAttribPointer(position,2,gl.FLOAT,false,0,0);
        try {
          [image,mask].forEach((source,index) => {
            gl.activeTexture(gl.TEXTURE0+index); gl.bindTexture(gl.TEXTURE_2D,gl.createTexture());
            gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
            gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,source);
            gl.uniform1i(gl.getUniformLocation(program,index?'waterMask':'photo'),index);
          });
        } catch { gl.getExtension('WEBGL_lose_context')?.loseContext(); return null; }
        gl.viewport(0,0,canvas.width,canvas.height);
        return {canvas,gl,program};
      }
      renderLake(scene, seconds) {
        if (!scene.ready || scene.frame === seconds) return;
        scene.frame = seconds;
        const context=scene.context, width=scene.surface.width, height=scene.surface.height;
        context.clearRect(0,0,width,height);
        if (scene.gpu && !scene.gpu.gl.isContextLost()) {
          const {gl,program,canvas}=scene.gpu;
          gl.uniform1f(gl.getUniformLocation(program,'time'),seconds);
          gl.uniform1f(gl.getUniformLocation(program,'horizon'),scene.mobile?.343:.38);
          gl.uniform1f(gl.getUniformLocation(program,'depthRange'),scene.mobile?.22:.28);
          gl.drawArrays(gl.TRIANGLES,0,6);
          context.drawImage(canvas,0,0);
        } else {
          const start=Math.floor(height*(scene.mobile?.347:.389)), end=Math.ceil(height*(scene.mobile?.57:.66));
          for(let y=start;y<end;y++) {
            const d=(y-start)/(end-start), phase=Math.log(1+d*8)*63-seconds*2.65;
            const x=Math.sin(phase)*width*.005*d, offset=Math.sin(phase+1)*height*.0028*d;
            context.drawImage(scene.image,0,(y+offset)/height*scene.image.naturalHeight,scene.image.naturalWidth,scene.image.naturalHeight/height,-width*.01+x,y,width*1.02,1.2);
          }
          context.globalCompositeOperation='destination-in';context.drawImage(scene.mask,0,0);context.globalCompositeOperation='source-over';
        }
        const fog=scene.fog.getContext('2d');
        fog.clearRect(0,0,width,height);
        const drift=(seconds*width*.046)%width;
        const top=height*(scene.mobile?.307:.317), fogHeight=height*(scene.mobile?.086:.18);
        fog.globalAlpha=.83;
        for(const x of [drift-width,drift]) fog.drawImage(this.mistTexture,x,top+Math.sin(seconds*.55)*height*.002,width,fogHeight);
        const driftBack=(seconds*width*.023)%width;
        fog.globalAlpha=.38;
        for(const x of [-driftBack,width-driftBack]) fog.drawImage(this.mistTexture,x,top+fogHeight*.12,width,fogHeight*.78);
        fog.globalAlpha=1;
        fog.globalCompositeOperation='destination-in';
        const vertical=fog.createLinearGradient(0,top,0,top+fogHeight);
        vertical.addColorStop(0,'transparent');vertical.addColorStop(.27,'white');
        vertical.addColorStop(.64,'white');vertical.addColorStop(1,'transparent');
        fog.fillStyle=vertical;fog.fillRect(0,0,width,height);
        if(!scene.mobile) {
          const protection=fog.createLinearGradient(0,0,width,0);
          [[0,1],[.396,1],[.421,0],[.47,0],[.496,1],[.627,1],[.678,0],[1,0]].forEach(([stop,alpha])=>protection.addColorStop(stop,`rgba(255,255,255,${alpha})`));
          fog.fillStyle=protection;fog.fillRect(0,0,width,height);
        }
        fog.globalCompositeOperation='source-over';
        context.drawImage(scene.fog,0,0);
      }
      drawMist(canvas, seconds) {
        const mobile = canvas.dataset.mist === 'mobile' || !this.desktop.matches;
        if (canvas.dataset.mist === 'mobile' && this.desktop.matches) return;
        const key=mobile?'mobile':'desktop';
        if(!this.lakeScenes[key]) this.lakeScenes[key]=this.createLake(mobile);
        const scene=this.lakeScenes[key];
        if(!scene.ready) return;
        const width=Math.round(canvas.clientWidth),height=Math.round(canvas.clientHeight);
        if(!width || !height) return;
        const scale=Math.min(window.devicePixelRatio||1,1.5,1440/width);
        const cw=Math.round(width*scale),ch=Math.round(height*scale);
        if(canvas.width!==cw || canvas.height!==ch){canvas.width=cw;canvas.height=ch;}
        const context=canvas.getContext('2d');
        context.clearRect(0,0,cw,ch);
        const ratio=scene.image.naturalWidth/scene.image.naturalHeight;
        const iw=mobile?cw:Math.min(cw,ch*ratio),ih=iw/ratio;
        this.renderLake(scene,seconds);
        context.drawImage(scene.surface,(cw-iw)/2,(ch-ih)/2,iw,ih);
        canvas.dataset.lakeMotion=scene.gpu?'water-reflections':'water-fallback';
      }
      draw() {
        if (!this.hasAttribute('data-scroll-ready')) return;
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--ta-sticky-top', Math.min(160, Math.max(0, rect.top + window.scrollY)) + 'px');
        const mobileTravel = Math.min(640, Math.max(420, window.innerHeight * .72));
        this.style.setProperty('--ta-mobile-travel', mobileTravel + 'px');
        const travel = this.desktop.matches ? 440 : mobileTravel;
        const progress = Math.max(0, Math.min(1, (80 - rect.top) / travel));
        const eased = progress * progress * (3 - 2 * progress);
        const reveal = Math.max(0, Math.min(1, (progress - .64) / .32));
        this.style.setProperty('--ta-progress', eased.toFixed(4));
        this.style.setProperty('--ta-reveal', reveal.toFixed(4));
        if (!this.desktop.matches) {
          const open = Math.max(0, Math.min(1, (progress - .08) / .76));
          const smoothOpen = open * open * (3 - 2 * open);
          const mobileReveal = Math.max(0, Math.min(1, (progress - .26) / .42));
          this.toggleAttribute('data-mobile-closed', smoothOpen <= .001);
          this.style.setProperty('--ta-open', smoothOpen.toFixed(4));
          this.style.setProperty('--ta-mobile-reveal', mobileReveal.toFixed(4));
          this.toggleAttribute('data-mobile-revealed', mobileReveal > .85);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        this.reduceMotion.removeEventListener('change', this.configure);
        this.mobileImages.forEach(image => image.removeEventListener('load', this.imageReady));
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.mistFrame);
        this.mistObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.wakeLake);
        Object.values(this.lakeScenes || {}).forEach(scene => {
          scene.image.onload = null;
          scene.gpu?.gl.getExtension('WEBGL_lose_context')?.loseContext();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
